module.exports = __webpack_public_path__ + "static/media/kick-that-habit-man.c8188f48.txt";